import { render, staticRenderFns } from "./PracticeNew.vue?vue&type=template&id=7e1fa9da&"
import script from "./PracticeNew.vue?vue&type=script&lang=ts&"
export * from "./PracticeNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports